var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12.999,
    viewBox: "0 0 10 12.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131388",
    "data-name": "Path 131388",
    d: "M59.988,5.352h-.651V3.476a3.677,3.677,0,0,0-7.344,0V5.352h-.65a.66.66,0,0,0-.678.642v6.365a.66.66,0,0,0,.678.641h8.645a.661.661,0,0,0,.678-.641V5.993A.661.661,0,0,0,59.988,5.352ZM53.349,3.476a2.32,2.32,0,0,1,4.633,0V5.352H53.349Z",
    transform: "translate(-50.666)",
    fill: "#0bbe11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/Unlocked.5b761fe5cda1b960cee7309a47ec969b.svg";
export { ForwardRef as ReactComponent };